import React from "react";
import MeetUsWrapper from "Components/MeetUsWrapper";
import styles from "./style.module.scss";
import CheckCircle from "../../../Utils/Assets/Images/CheckCircle.png";
import Explore from "../../../Utils/Assets/Images/Explore2.png";
import YouRecieveCoins from "../../../Utils/Assets/Images/youReceiveCoins.png";
import { motion } from "framer-motion";

const WhatIsMVR = () => {
    const textVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.1,
                duration: 0.8,
                ease: [0.25, 0.46, 0.45, 0.94],
            },
        }),
    };

    const itemVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: (i) => ({
            opacity: 1,
            x: 0,
            transition: {
                delay: 0.4 + i * 0.15,
                duration: 0.6,
                ease: "easeOut",
            },
        }),
    };

    return (
        <div className={styles.root}>
            <MeetUsWrapper>
                <div className={styles.CardContainer}>
                    <div
                        className={styles.Card2}
                        data-aos="fade-up"
                        data-aos-duration="1000"
                    >
                        <div className={styles.CardTitle}>
                            <motion.h1
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                custom={0}
                                variants={textVariants}
                            >
                                What is MVR Influence Coin?
                            </motion.h1>
                            <motion.p
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                custom={1}
                                variants={textVariants}
                            >
                                MVR Influence Coin is designed for platform
                                staking, brand engagement, and influencer
                                rewards. Earn Influence Coins by completing
                                tasks, engaging with brands, and participating
                                in MeetusVR’s ecosystem.
                            </motion.p>
                        </div>
                        <div className={styles.CardContent}>
                            {[
                                "Earn by interacting with brands, completing surveys, and participating in VR events.",
                                "Stake Influence Coins to unlock cashback, fee discounts, and influencer perks.",
                                "Higher levels = more brand deals, referral earnings, and hosting opportunities.",
                            ].map((text, index) => (
                                <motion.div
                                    key={index}
                                    className={styles.flex}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    custom={index}
                                    variants={itemVariants}
                                >
                                    <img src={CheckCircle} alt="Check Circle" />
                                    <p>{text}</p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                    <div
                        data-aos="fade-right"
                        data-aos-duration="1000"
                        data-aos-once="false"
                        className={styles.Card1}
                    >
                        <div className={styles.CardImage}>
                            <img src={Explore} alt="Explore" />
                            <img
                                src={YouRecieveCoins}
                                alt="You Receive Coins"
                                className={styles.YouRecieveCoins}
                            />
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default WhatIsMVR;
